import { useState, useCallback, useEffect } from "react";

const CELEBRATION_DURATION_MS = 3500;

const useGoalCelebration = () => {
  const [isCelebrating, setIsCelebrating] = useState(false);

  const startCelebration = useCallback(() => {
    setIsCelebrating(true);
  }, []);

  const stopCelebration = useCallback(() => {
    setIsCelebrating(false);
  }, []);

  useEffect(() => {
    if (!isCelebrating) return;

    const timer = setTimeout(stopCelebration, CELEBRATION_DURATION_MS);
    return () => clearTimeout(timer);
  }, [isCelebrating, stopCelebration]);

  return { isCelebrating, startCelebration, stopCelebration };
};

export default useGoalCelebration;
